<template>
    <div class="select-group">
        <select v-model="selectData" @change="select()" class="filter-select">
            <option value="0" v-html="defaultOption"></option>
            <option v-for="option in options" :value="option" :fieldId="option.name" :label="option.name" :slug="option.slug" :key="option" v-html="option.name"></option>
        </select>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                selectData: '0',
                defaultOption: 'Select an option'
            }
        },
        emits: ["update:value" ,"reset:all"],
        props: {
            value: {
                type: Array,
                required: true,
            },
            options: {
                type: Array,
                required: true,
                validator: (value) => {
                    const hasNameKey = value.every((option) =>
                        Object.keys(option).includes("name")
                    );
                    const hasIdKey = value.every((option) =>
                        Object.keys(option).includes("id")
                    );
                    return hasNameKey && hasIdKey;
                },
            },
        },
        methods: {
            select() {
                let updatedValue = [];

                if (typeof this.selectData === 'object') {
                    let filterObject = {
                        name: this.selectData.name,
                        slug: this.selectData.slug,
                        id: this.selectData.id
                    }

                    updatedValue.push(filterObject);
                }

                this.$emit("update:value", updatedValue);
            }
        },
    };
</script>
